// Helper compartido para representar visualmente una notificación (NotificacionDto)
// según su campo `origen`. Extraído de NotificacionCampana.js para que la campana,
// el panel del Home y NotificacionesPage muestren siempre el mismo ícono y color.

/**
 * Devuelve { icon, color } según el origen de la notificación.
 * @param {{ origen?: string }} notificacion
 */
export function iconoPorOrigen(notificacion) {
    switch (notificacion?.origen) {
        case 'ANSES':
            return { icon: 'bi-folder2-open', color: '#2563eb' };
        case 'GMAIL':
        case 'OUTLOOK':
            return { icon: 'bi-envelope-fill', color: '#6B7280' };
        default:
            return { icon: 'bi-calendar3', color: '#d97706' };
    }
}
